import styles from "./EntrepreneurAddOrEditProduct.module.css";

import rightArrow from "../../assets/SetaDireita.svg";
import newImageIcon from "../../assets/newImageIcon.svg";
import plusIcon from "../../assets/plusIcon.svg";
import minusIcon from "../../assets/minusIcon.svg";
import summaryIcon from "../../assets/summaryIcon.svg";
import feeIcon from "../../assets/feeIcon.svg";

import * as ProductSchemas from "./schemas";

import { useTranslation } from "react-i18next";
import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import api from "../../utils/axios/api";
import { useNavigate, useParams } from "react-router-dom";
import { Modal } from "./Modal";
import { categories } from "../../utils/category";
import { brands } from "../../utils/brand";
import { problemSolutions } from "../../utils/problem-solutions";
import { Produto } from "../CardProduto/CardProduto";
import { stageSubCategory } from "../../utils/stage-subcategory";
import { FaTrashAlt } from "react-icons/fa";
import { useCalculateWithFee } from "../../utils/fee";
import { useFee } from "../../context/FeeContext";
import { toast } from "sonner";

interface EntrepreneurAddOrEditProductProps {
  action: "add" | "edit";
}

export type Specifications = {
  specification: string;
  description: string;
};

type ProductProblems = {
  problem: string;
  solutions: string[];
};

type StageSubCategory = {
  stage: string;
  subcategory: string[];
};

const EntrepreneurAddOrEditProduct = ({
  action,
}: EntrepreneurAddOrEditProductProps) => {
  const { t, i18n } = useTranslation();
  const calcWithFee = useCalculateWithFee();

  const { id: productId } = useParams();

  const [productImages, setProductImages] = useState<Array<string>>([]);
  const [productQuantity, setProductQuantity] = useState<number>(1);
  const [productPrivacy, setProductPrivacy] = useState(true);
  const [productPrice, setProductPrice] = useState<string>("");
  const [productPromotionalPrice, setProductPromotionalPrice] = useState<
    number | undefined
  >(undefined);
  const [productDescription, setProductDescription] = useState<string>("");
  const [productProblem, setProductProblem] = useState<ProductProblems[]>([]);
  const [stageSub, setStageSub] = useState<StageSubCategory[]>([]);
  const [productName, setProductName] = useState<string>("");
  const [productCategories, setProductCategories] = useState<string[]>([]);
  const [productBrand, setProductBrand] = useState<string>("");
  const [productAcceptTerms, setProductAcceptTerms] = useState<boolean>(false);
  const [productAllowOffer, setProductAllowOffer] = useState<boolean>(false);
  const [modal, setModal] = useState<boolean>(false);
  const [specifications, setSpecifications] = useState<Specifications[]>([]);
  /** Paralelo a `productImages`: valor quando o slot veio de arquivo novo (upload). */
  const [imageSourceFiles, setImageSourceFiles] = useState<(File | null)[]>([]);
  const { fee, changeFee } = useFee()

  const [arrowButtonDisabled, setArrowButtonDisabled] =
    useState<boolean>(false);
  const navigate = useNavigate();

  const ref_scrollSummaryProductImages = useRef<HTMLDivElement | null>(null);

  //TODO: pegar a loja do entrepreneur logado
  const storeId = localStorage.getItem("storeId");

  //TODO: Apenas exemplos por enquanto, depois tem que pegar do backend
  const termsEntrepreneur = [
    "Atualizar com as informações do cliente",
  ];

  //TODO: Apenas exemplos por enquanto, depois tem que pegar do backend


  const currencyLocalFormat = (value: number) => {
    return value.toLocaleString(i18n.language || "pt-BR", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
  };

  function isRemoteImageUrl(s: string): boolean {
    return /^https?:\/\//i.test(s);
  }

  const handleInputFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const list = event.currentTarget.files;
    if (!list?.length) return;
    const files = Array.from(list);
    const readOne = (file: File) =>
      new Promise<{ preview: string; file: File }>((resolve) => {
        const reader = new FileReader();
        reader.onload = () =>
          resolve({ preview: reader.result as string, file });
        reader.readAsDataURL(file);
      });
    const items = await Promise.all(files.map(readOne));
    setProductImages((prev) => [...prev, ...items.map((x) => x.preview)]);
    setImageSourceFiles((prev) => [...prev, ...items.map((x) => x.file)]);
    event.currentTarget.value = "";
  };

  const handleDecreaseProductQuantity = () => {
    setProductQuantity((prev) => (prev > 1 ? prev - 1 : 1));
  };
  const handleIncreaseProductQuantity = () => {
    setProductQuantity((prev) => prev + 1);
  };

  const handleScrollSummaryProductImage = (direction: string) => {
    if (ref_scrollSummaryProductImages.current) {
      setArrowButtonDisabled(true);
      // Reativando o botão ao fim do scroll
      setTimeout(() => {
        setArrowButtonDisabled((prev) => !prev);
      }, 200);
      const clientWidth = ref_scrollSummaryProductImages.current.clientWidth;
      const scrollWidth = ref_scrollSummaryProductImages.current.scrollWidth;
      if (direction.trim().toLowerCase() === "left") {
        ref_scrollSummaryProductImages.current.scrollLeft -= clientWidth;
        if (ref_scrollSummaryProductImages.current.scrollLeft < 0)
          ref_scrollSummaryProductImages.current.scrollLeft = 0;
      } else if (direction.trim().toLocaleLowerCase() === "right") {
        ref_scrollSummaryProductImages.current.scrollLeft += clientWidth;
        if (ref_scrollSummaryProductImages.current.scrollLeft > scrollWidth)
          ref_scrollSummaryProductImages.current.scrollLeft = scrollWidth;
      }
    }
  };

  const handleFetchProduct = async () => {
    try {
      const response = await api.get(`/product/${productId}`);
      setSpecifications(response.data.specifications);
      setProductName(response.data.name);
      setProductCategories(
        typeof response.data.category === "string" &&
          response.data.category !== ""
          ? response.data.category.split(",").filter((cat: string) =>
              categories.some(c => c.name === cat.trim())
            )
          : []
      );
      setProductPrice(response.data.originalPrice.toString());
      setProductDescription(response.data.description);
      setProductBrand(response.data.brand);

      const solutionsProblem: string[] =
        typeof response.data.solutions === "string"
          ? response.data.solutions.split("$")
          : [];
      const problems: string[] =
        typeof response.data.problems === "string"
          ? response.data.problems.split("$")
          : [];

      const stagesSub: string[] =
        typeof response.data.subcategory === "string"
          ? response.data.subcategory.split("$")
          : [];
      const stages: string[] =
        typeof response.data.stage === "string"
          ? response.data.stage.split("$")
          : [];

      const productProblem: ProductProblems[] = problems.map((item, idx) => {
        if (solutionsProblem.length < idx)
          return {
            problem: item,
            solutions: [],
          };

        return {
          problem: item,
          solutions: solutionsProblem[idx].split("#"),
        };
      }).filter(item => item.problem !== "");

      const stagesWithSub: StageSubCategory[] = stages.map((item, idx) => {
        if (stagesSub.length < idx)
          return {
            stage: item,
            subcategory: [],
          };

        return {
          stage: item,
          subcategory: stagesSub[idx].split("#"),
        };
      }).filter(item => item.stage !== "");

      setProductProblem(productProblem);
      setStageSub(stagesWithSub);
      // setProductSolution(response.data.solutions);
      setProductQuantity(response.data.quantity);
      const main = response.data.image as string | undefined;
      const extras: string[] = Array.isArray(response.data.additionalImages)
        ? response.data.additionalImages
        : [];
      const urls = [main, ...extras].filter(
        (u): u is string => typeof u === "string" && u.length > 0
      );
      setProductImages(urls);
      setImageSourceFiles(urls.map(() => null));
      setProductAcceptTerms(true);
    } catch (e) {
      console.error("Erro ao buscar o produto: " + e);
    }
  };

  useEffect(() => {
    if (productId) {
      handleFetchProduct();
    }
  }, []);

  //TODO: allowOffer e privacy não são usados no backend, onde salvar?
  //TODO: atributos não consigurados na pagina: solutions e problems, space, brand
  const handleSubmitForm = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    //TODO: não tem ainda um local para salvar a imagem e obter uma URL
    const remoteAdditionalUrls = productImages
      .slice(1)
      .filter((url, i) => {
        const slotFile = imageSourceFiles[i + 1];
        return !slotFile && isRemoteImageUrl(url);
      });

    const mainImageBody =
      productImages.length === 0
        ? ""
        : imageSourceFiles[0]
          ? ""
          : productImages[0];

    const formData = {
      name: productName,
      category: productCategories.join(","),
      description: productDescription,
      price: Number(productPrice),
      quantity: Number(productQuantity),
      privacy: productPrivacy,
      acceptTerms: productAcceptTerms,
      allowOffer: productAllowOffer,
      promotionalPrice: productPromotionalPrice
        ? productPromotionalPrice
        : null,
      image: mainImageBody,
    };

    const result = ProductSchemas.productSchema.safeParse(formData);
    if (!result.success) {
      // Se houver erros, substitui as mensagens por versões traduzidas
      const translatedErrors = result.error.issues.map((issue) => {
        return {
          ...issue,
          message: t(issue.message),
        };
      });

      console.error("Erro na validação:", translatedErrors);
      return;
    }

    //FIXME: inventando propriedades que eu não configuro na pagina
    const finalProduct = {
      ...result.data,
      image: mainImageBody,
      additionalImages: JSON.stringify(remoteAdditionalUrls),
      originalPrice: result.data.price,
      storeId: storeId,
      space: "espaço", // TODO: não estão como opções no back, confirmar se é necessário
      weight: 10,
      specifications,
      brand: productBrand,
      problems: productProblem.map((item) => item.problem).join("$"),
      solutions: productProblem
        .map((item) => item.solutions.join("#"))
        .join("$"),
      stage: stageSub.map((item) => item.stage).join("$"),
      subcategory: stageSub.map((item) => item.subcategory.join("#")).join("$"),
    };

    const formData2 = new FormData();

    Object.entries(finalProduct).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        let dataToAppend: string | Blob;
        if (value instanceof Blob) {
          dataToAppend = value;
        } else if (typeof value === "object") {
          dataToAppend = JSON.stringify(value);
        } else {
          dataToAppend = value.toString();
        }
        formData2.append(key, dataToAppend);
      }
    });
    // ...existing code...

    if (imageSourceFiles[0]) {
      formData2.append("file", imageSourceFiles[0]);
    }
    imageSourceFiles.slice(1).forEach((f) => {
      if (f) formData2.append("additionalFiles", f);
    });

    try {
      if (productId && action === "edit")
        await api.put(`/product/${productId}`, formData2, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      else if (!productId && action === "add")
        await api.post(`/product`, formData2, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      toast.success('Produto criado com sucesso!')
      await new Promise(resolve => setTimeout(resolve, 1500))
      navigate("/auth/entrepreneur/account/products/list");
    } catch (error) {
      toast.error('Erro ao criar produto. Por favor, tente mais tarde.')
    }
  };

  const handleSubmitCancel = () => {
    setProductImages([]);
    setImageSourceFiles([]);
    setProductQuantity(1);
    setProductPrivacy(true);
    setProductPrice("");
    setProductDescription("");
    setProductProblem([]);
    setStageSub([]);
    // setProductSolution([]);
    setProductName("");
    setProductCategories([]);
    setProductAcceptTerms(false);
    setProductAllowOffer(false);
    setArrowButtonDisabled(false);
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = event.target;

    if (checked) {
      setProductCategories((prevCategories) => [...prevCategories, name]);
    } else {
      setProductCategories((prevCategories) =>
        prevCategories.filter((category) => category !== name)
      );
    }
  };

  const handleChangeSolutions = (
    event: ChangeEvent<HTMLInputElement>,
    idx: number
  ) => {
    const { name, checked } = event.target;

    if (checked) {
      setProductProblem((prevCategories) => {
        const aux = [...prevCategories];
        aux[idx].solutions = [...aux[idx].solutions, name];
        return aux;
      });
    } else {
      setProductProblem((prevCategories) => {
        const aux = [...prevCategories];
        aux[idx].solutions = aux[idx].solutions.filter(
          (solution) => solution !== name
        );
        return aux;
      });
    }
  };

  const handleChangeStage = (
    event: ChangeEvent<HTMLInputElement>,
    idx: number
  ) => {
    const { name, checked } = event.target;
    console.log(name);
    console.log(checked);
    console.log(idx);

    console.log(stageSub);

    if (checked) {
      setStageSub((prevCategories) => {
        const aux = [...prevCategories];
        aux[idx].subcategory = [...aux[idx].subcategory, name];
        return aux;
      });
    } else {
      setStageSub((prevCategories) => {
        const aux = [...prevCategories];
        aux[idx].subcategory = aux[idx].subcategory.filter(
          (subcategory) => subcategory !== name
        );
        return aux;
      });
    }
  };

  const [products, setProducts] = useState<Produto[]>([]); // Todos os produtos
  const [filteredProducts, setFilteredProducts] = useState<Produto[]>([]); // Produtos filtrados

  // Carregar todos os produtos uma única vez
  useEffect(() => {
    async function loadAllProducts() {
      try {
        const [response, responseFee] = await Promise.all([
          api.get("/product"),
          api.get('/fee/Taxa de venda geral')
        ]); // Carregar todos os produtos
        setProducts(response.data); // Armazena o array completo
        setFilteredProducts(response.data.slice(0, 5)); // Define os primeiros 5 produtos inicialmente
        changeFee(responseFee.data.value)

      } catch (error) {
        console.error("Erro ao carregar os produtos:", error);
      }
    }

    loadAllProducts(); // Executa apenas uma vez
  }, []);

  const [isListVisible, setIsListVisible] = useState<boolean>(false);

  useEffect(() => {
    const filtered = products
      .filter((product) =>
        product.name.toLowerCase().includes(productName.toLowerCase())
      )
      .slice(0, 5); // Limita a 5 sugestões

    setFilteredProducts(filtered);
  }, [productName, products]);

  function removeProblem(idx: number) {
    const aux = [...productProblem]
    aux.splice(idx, 1)
    setProductProblem(aux)
  }

  function removeStage(idx: number) {
    const aux = [...stageSub]
    aux.splice(idx, 1)
    setStageSub(aux)
  }

  function removeImage(idx: number) {
    setProductImages((prev) => {
      const aux = [...prev];
      aux.splice(idx, 1);
      return aux;
    });
    setImageSourceFiles((prev) => {
      const aux = [...prev];
      aux.splice(idx, 1);
      return aux;
    });
  }

  return (
    <div style={{ position: "relative" }}>
      <h2 className={styles.mainTitle}>
        {action === "add" && t(`accountMenu.addProduct`)}
        {action === "edit" && t(`accountMenu.editProduct`)}
      </h2>
      {modal && (
        <Modal
          setSpecifications={setSpecifications}
          specifications={specifications}
          closeModal={() => setModal(false)}
        />
      )}
      <form
        className={styles.productContainer}
        onSubmit={handleSubmitForm}
        style={{ opacity: modal ? "20%" : undefined }}
      >
        <div className={styles.productDataContainer}>
          <div
            className={`${styles.productContainerSubsection} ${styles.aboutProduct}`}
          >
            <h3>{t(`accountMenu.aboutProduct`)}</h3>
            <div className={styles.productNameContainer}>
              <p className={styles.paragraphSubtitle}>
                {t(`accountMenu.productName`)}
              </p>
              <div style={{ position: "relative" }}>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <input
                    type="text"
                    placeholder={t(`accountMenu.name`)}
                    name="name"
                    value={productName}
                    onChange={(event) => {
                      setProductName(event.currentTarget.value);
                      const filtered = products
                        .filter((product) =>
                          product.name
                            .toLowerCase()
                            .includes(event.currentTarget.value.toLowerCase())
                        )
                        .slice(0, 5);
                      setFilteredProducts(filtered);
                    }}
                    required
                    style={{ width: "100%" }}
                  />
                  <button
                    type="button"
                    onClick={() => setIsListVisible((prev) => !prev)}
                    style={{
                      padding: "5px 10px",
                      cursor: "pointer",
                      border: "1px solid #ccc",
                      backgroundColor: "#f9f9f9",
                      borderRadius: "4px",
                    }}
                  >
                    {isListVisible ? "Fechar" : "Abrir"}
                  </button>
                </div>
                {isListVisible && filteredProducts.length > 0 && (
                  <ul
                    style={{
                      listStyleType: "none",
                      padding: 0,
                      margin: 0,
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      width: "100%",
                      border: "1px solid #ccc",
                      backgroundColor: "#fff",
                      zIndex: 10,
                      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    {filteredProducts.map((product) => (
                      <li
                        key={product.id}
                        style={{
                          padding: "10px",
                          cursor: "pointer",
                          borderBottom: "1px solid #ddd",
                          color: "#333",
                        }}
                        onMouseDown={() => {
                          setProductName(product.name);
                          setProductDescription(product.description);
                          setProductPrice(product.originalPrice.toString());
                          setProductCategories(
                            product.category.toString().split(",").filter((cat: string) =>
                              categories.some(c => c.name === cat.trim())
                            )
                          );
                          setProductBrand(product.brand || "");
                          setProductQuantity(product.quantity || 1);
                          const imgs = [
                            product.image,
                            ...(product.additionalImages ?? []),
                          ].filter(
                            (u): u is string =>
                              typeof u === "string" && u.length > 0
                          );
                          setProductImages(imgs);
                          setImageSourceFiles(imgs.map(() => null));
                          setIsListVisible(false); // Fecha a lista ao selecionar
                        }}
                      >
                        {product.name}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              <textarea
                cols={30}
                rows={10}
                placeholder={t(`accountMenu.description`)}
                value={productDescription}
                onChange={(event) =>
                  setProductDescription(event.currentTarget.value)
                }
                name="description"
                required
              />
              <div className={styles.problemSolutionDiv}>
                <div className={styles.selectProblemContainer}>
                  <h3>{t(`accountMenu.problemXsolution`)}</h3>
                  {productProblem.map(({ problem }, idx) => (
                    <div key={idx}>
                      <div>
                        <select
                          name="problemSelected"
                          style={{ width: "100%" }}
                          value={problem}
                          onChange={(event) => {
                            const selectedValue = event.currentTarget.value;
                            setProductProblem((prevState) => {
                              if (selectedValue === problem) return prevState;
                              if (
                                prevState.find(
                                  (item) => item.problem === selectedValue
                                )
                              )
                                return prevState;
                              const aux = [...prevState];

                              aux[idx] = {
                                problem: selectedValue,
                                solutions: [],
                              };

                              return aux;
                            });
                          }}
                        >
                          <option hidden disabled value="">
                            {t(`accountMenu.manufacturer`)}
                          </option>
                          {Array.from(problemSolutions, ([problem]) => (
                            <option key={problem} value={problem}>
                              {problem}
                            </option>
                          ))}
                        </select>
                        <span className={styles.remove} onClick={() => removeProblem(idx)}>X</span>
                      </div>
                      {problemSolutions
                        .get(problem)
                        ?.solutions.map((solution, idxSolution) => (
                          <div
                            key={idxSolution}
                            className={styles.wrapperCheckbox}
                          >
                            <input
                              // className={styles.checkbox}
                              type="checkbox"
                              name={solution}
                              id={solution}
                              onChange={(e) => handleChangeSolutions(e, idx)}
                              checked={productProblem[idx].solutions.some(
                                (solutionChecked) =>
                                  solutionChecked === solution
                              )}
                            />
                            <label htmlFor={solution}>{solution}</label>
                          </div>
                        ))}
                    </div>
                  ))}
                  <select
                    name="problem"
                    value={""}
                    onChange={(event) => {
                      const selectedValue = event.currentTarget.value;
                      setProductProblem((prevState) => {
                        if (
                          prevState.find(
                            (prevState) => prevState.problem === selectedValue
                          )
                        )
                          return prevState;
                        return [
                          ...prevState,
                          { problem: selectedValue, solutions: [] },
                        ];
                      });
                    }}
                  >
                    <option hidden disabled value="">
                      {t(`accountMenu.problem`)}
                    </option>
                    {Array.from(problemSolutions, ([problem]) => (
                      <option key={problem} value={problem}>
                        {problem}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className={styles.problemSolutionDiv}>
                <div className={styles.selectProblemContainer}>
                  <h3>{t(`accountMenu.stageSub`)}</h3>
                  {stageSub.map(({ stage }, idx) => (
                    <div key={idx}>
                      <div>
                        <select
                          name="stageSubcategory"
                          style={{ width: "100%" }}
                          value={stage}
                          onChange={(event) => {
                            const selectedValue = event.currentTarget.value;
                            setStageSub((prevState) => {
                              if (selectedValue === stage) return prevState;
                              if (
                                prevState.find(
                                  (item) => item.stage === selectedValue
                                )
                              )
                                return prevState;
                              const aux = [...prevState];
                              aux[idx] = {
                                stage: selectedValue,
                                subcategory: [],
                              };

                              return aux;
                            });
                          }}
                        >
                          <option hidden disabled value="">
                            {t(`accountMenu.manufacturer`)}
                          </option>
                          {Array.from(stageSubCategory, ([stage]) => (
                            <option key={stage} value={stage}>
                              {stage}
                            </option>
                          ))}
                        </select>
                        <span className={styles.remove} onClick={() => removeStage(idx)}>X</span>
                      </div>
                      {stageSubCategory
                        .get(stage)
                        ?.subcategory.map((sub, idxSub) => (
                          <div key={idxSub} className={styles.wrapperCheckbox}>
                            <input
                              // className={styles.checkbox}
                              type="checkbox"
                              name={sub}
                              id={stage + sub}
                              onChange={(e) => handleChangeStage(e, idx)}
                              checked={stageSub[idx].subcategory.some(
                                (subChecked) => {
                                  return subChecked === sub;
                                }
                              )}
                            />
                            <label htmlFor={sub}>{sub}</label>
                          </div>
                        ))}
                    </div>
                  ))}
                  <select
                    name="stage"
                    value={""}
                    onChange={(event) => {
                      const selectedValue = event.currentTarget.value;
                      setStageSub((prevState) => {
                        if (
                          prevState.find(
                            (prevState) => prevState.stage === selectedValue
                          )
                        )
                          return prevState;
                        return [
                          ...prevState,
                          { stage: selectedValue, subcategory: [] },
                        ];
                      });
                    }}
                  >
                    <option hidden disabled value="">
                      {t(`accountMenu.stageSub`)}
                    </option>
                    {Array.from(stageSubCategory, ([stage]) => (
                      <option key={stage} value={stage}>
                        {stage}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <h3>{t(`accountMenu.features`)}</h3>
              <div className={styles.selectCategoryContainer}>
                <select
                  name="brand"
                  required
                  value={productBrand}
                  onChange={(event) =>
                    setProductBrand(event.currentTarget.value)
                  }
                >
                  <option hidden disabled value="">
                    {t(`accountMenu.manufacturer`)}
                  </option>
                  {brands.map((brand) => (
                    <option key={brand.name} value={brand.name}>
                      {brand.name}
                    </option>
                  ))}
                </select>
                <span
                  className={styles.addSpecification}
                  onClick={() => setModal(true)}
                >
                  Adicionar especificações
                </span>
              </div>
              <p className={styles.paragraphSubtitle}>
                {t(`accountMenu.categoryProduct`)}
              </p>
              <div className={styles.selectCategory}>
                {categories.map((item, key) => (
                  <div key={key} className={styles.wrapperCheckbox}>
                    <input
                      // className={styles.checkbox}
                      type="checkbox"
                      name={item.name}
                      id={item.name}
                      onChange={(e) => handleChange(e)}
                      checked={productCategories.some(
                        (category) => category === item.name
                      )}
                    />
                    <label htmlFor={item.name}>{item.name}</label>
                  </div>
                ))}
              </div>
              {/* <div className={styles.selectCategoryContainer}>
                <select
                  name="category"
                  required
                  value={productCategory}
                  onChange={(event) =>
                    setProductCategory(event.currentTarget.value)
                  }
                >
                  <option hidden disabled value="">
                    {t(`accountMenu.category`)}
                  </option>
                  {categories.map((category) => (
                    <option
                      key={category.name}
                      value={category.name}
                    >
                      {category.name}
                    </option>
                  ))}
                </select>
              </div> */}
            </div>
          </div>
          <div
            className={`${styles.pictureContainer} ${styles.productContainerSubsection}`}
          >
            <h3>{t(`accountMenu.picture`)}</h3>
            <p className={styles.paragraphSubtitle}>
              {t(`accountMenu.pickPhoto`)}
            </p>
            <div className={styles.productImagesContainer}>
              {productImages.map((imageSrc, index) => {
                return (
                  <div
                    className={styles.imageAddedContainer}
                    key={imageSrc + index}
                  >
                    <img src={imageSrc} className={styles.productImage} />
                    <FaTrashAlt onClick={() => removeImage(index)} className={styles.imageDelete} size={16} />
                  </div>
                );
              })}
              {/*O input em si fica escondido com display: none, a label que traz a funcionalidade*/}
              <input
                type="file"
                name="uploadInput"
                id="uploadInput"
                accept="image/*"
                multiple
                onChange={(event) => handleInputFileChange(event)}
              />
              <label htmlFor="uploadInput">
                <img src={newImageIcon} />
              </label>
            </div>
          </div>
          <div
            className={`${styles.priceContainer} ${styles.productContainerSubsection}`}
          >
            <h3>{t(`accountMenu.price`)}</h3>
            <p className={styles.paragraphSubtitle}>
              {t(`accountMenu.definePrice`)}
            </p>
            <div className={styles.productValueInputContainer}>
              <input
                type="number"
                step={0.01}
                max={1000000}
                min={0}
                name="productPriceInput"
                id="productPriceInput"
                placeholder={t(`accountMenu.value`)}
                value={productPrice}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  setProductPrice(event.currentTarget.value)
                }
                required
              />
              <div className={styles.checkboxAllowOfferContainer}>
                <input
                  type="checkbox"
                  name="allowOffer"
                  id="allowOffer"
                  checked={productAllowOffer}
                  onChange={(event) => {
                    setProductAllowOffer(event.currentTarget.checked);
                    if (!event.currentTarget.checked) {
                      setProductPromotionalPrice(undefined);
                    }
                  }}
                />
                <label htmlFor="allowOffer">
                  {t(`accountMenu.allowOffer`)}?
                </label>
              </div>
            </div>
          </div>
          <div>
            {productAllowOffer && (
              <div className={styles.criarOfertaContainer}>
                <h2>Criar Oferta</h2>
                <input
                  type="number"
                  step={0.01}
                  max={100000000}
                  min={0}
                  name="productOfferInput"
                  id="productOfferInput"
                  placeholder={t(`accountMenu.promotionalPrice`)}
                  value={productPromotionalPrice ?? ""}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    const value = event.currentTarget.value;
                    const preconum = parseFloat(productPrice);

                    if (value === "") {
                      setProductPromotionalPrice(undefined);
                    } else {
                      const numericValue = parseFloat(value);

                      if (numericValue >= 0 && numericValue <= preconum) {
                        setProductPromotionalPrice(numericValue);
                      }
                    }
                  }}
                  required
                />
              </div>
            )}
          </div>
          <div
            className={`${styles.stockContainer} ${styles.productContainerSubsection}`}
          >
            <h3>{t(`accountMenu.stock`)}</h3>
            <div className={styles.stockContentContainer}>
              <p className={styles.paragraphSubtitle}>
                {t(`accountMenu.stockProductQuantity`)}
              </p>
              <div className={styles.stockComponentContainer}>
                <img src={minusIcon} onClick={handleDecreaseProductQuantity} />
                <input value={productQuantity} onChange={(e) => {
                  const numb = Number(e.target.value)
                  if (!Number.isNaN(numb))
                    setProductQuantity(numb)
                }} className={styles.inputStock} style={{ backgroundColor: 'white', border: 'white', width: 80, textAlign: 'center' }} />
                <img src={plusIcon} onClick={handleIncreaseProductQuantity} />
              </div>
            </div>
          </div>
          <div
            className={`${styles.termsContainer} ${styles.productContainerSubsection}`}
          >
            <h3>{t(`accountMenu.terms`)}</h3>
            {termsEntrepreneur.map((term) => {
              return (
                <p key={term} className={styles.paragraphTerms}>
                  {term}
                </p>
              );
            })}
            <div className={styles.checkboxAcceptTerms}>
              <input
                type="checkbox"
                name="acceptTerms"
                id="acceptTerms"
                checked={productAcceptTerms}
                onChange={(event) =>
                  setProductAcceptTerms(event.currentTarget.checked)
                }
                required
              />
              <label htmlFor="acceptTerms">{t(`accountMenu.accept`)}</label>
            </div>
          </div>
        </div>
        <div className={styles.productSummaryContainer}>
          <div className={styles.productSummaryTitleContainer}>
            <img src={summaryIcon} />
            <h3>{t(`accountMenu.summary`)}</h3>
          </div>
          <div className={styles.priceSummaryContainer}>
            <span>{t(`accountMenu.price`)}</span>
            <span>
              {!productAllowOffer
                ? `R$ ${calcWithFee(Number(productPrice))}`
                : `R$ ${calcWithFee(Number(productPromotionalPrice))}`
              }
            </span>
          </div>
          <hr />
          <h4>{t(`accountMenu.view`)}</h4>
          {/*Converter em componente card*/}
          <div className={styles.productSummaryCardContainer}>
            <div className={styles.productSummaryCardImagesContainer}>
              <div
                className={styles.productImagesScrollContainer}
                ref={ref_scrollSummaryProductImages}
              >
                {productImages.map((imageSrc, imgIdx) => {
                  return (
                    <img
                      key={`${imgIdx}-${imageSrc.slice(0, 48)}`}
                      src={imageSrc}
                      className={styles.productImageItself}
                    />
                  );
                })}
              </div>
              {/*Exibe as setinhas pra ver as imagens no resumo quando há mais de uma*/}
              {productImages && productImages.length > 1 && (
                <>
                  <button
                    disabled={arrowButtonDisabled}
                    type="button"
                    style={{ backgroundImage: `url(${rightArrow})` }}
                    className={`${styles.rightArrow} ${styles.arrowProductImage}`}
                    onClick={() => handleScrollSummaryProductImage("right")}
                  ></button>
                  <button
                    disabled={arrowButtonDisabled}
                    type="button"
                    style={{ backgroundImage: `url(${rightArrow})` }}
                    className={`${styles.leftArrow} ${styles.arrowProductImage}`}
                    onClick={() => handleScrollSummaryProductImage("left")}
                  ></button>
                </>
              )}
            </div>
          </div>
          <div className={styles.productSummaryCardTextContainer}>
            <div>
              {productAllowOffer ? (
                <div className={styles.promotionContainer}>
                  {t("cardProduto.promotion")}
                </div>
              ) : (
                <></>
              )}
            </div>
            <h3>{productName}</h3>
            <p>{productDescription}</p>
            <p>{productBrand}</p>
            <span>{productCategories.join(", ")}</span>
            <div className={styles.codeAndPriceContainer}>
              <span className={styles.productPriceCard}>
                {!productAllowOffer
                  ? `R$ ${calcWithFee(Number(productPrice))}`
                  : `R$ ${calcWithFee(Number(productPromotionalPrice))}`
                }
              </span>
            </div>
          </div>
          <input
            type="submit"
            value={t(`accountMenu.postAd`)}
            className={styles.submitButton}
          />
          <button
            onClick={handleSubmitCancel}
            className={styles.cancelButton}
            type="button"
          >
            {t(`accountMenu.cancel`)}
          </button>
          <hr />
          <div className={styles.productFeesContainer}>
            <div className={styles.feesInfoContainer}>
              <div className={styles.feesTitle}>
                <span>{t(`accountMenu.values`)}</span>
                <img src={feeIcon} />
              </div>
              <p>{t(`accountMenu.feesApplied`)}.</p>
            </div>
            <ul>
              <li>
                <span>{t(`accountMenu.fee`)}</span>
                {fee && <span>{fee}%</span>}
              </li>
              <li>
                <span>{t(`accountMenu.total`)}</span>
                {fee && <span
                  className={
                    productPromotionalPrice
                      ? styles.precoRiscado
                      : styles.precoNormal
                  }
                >
                  R${" "}
                  {calcWithFee(Number(productPrice))}
                </span>}
                {productPromotionalPrice && (
                  <div>
                    <span className={styles.discountNumber}>
                      {(
                        100 -
                        (productPromotionalPrice / Number(productPrice)) * 100
                      ).toFixed(2)}
                      % de Desconto
                    </span>

                    {fee && <span>
                      R${" "}
                      {calcWithFee(Number(productPromotionalPrice))}
                    </span>}
                  </div>
                )}
              </li>
            </ul>
          </div>
        </div>
      </form>
    </div>
  );
};

export default EntrepreneurAddOrEditProduct;
